import type { ColDef } from 'ag-grid-enterprise';

/**
 * Column props for an icon-only column — reorder handles, row actions,
 * favourite toggles — that is too narrow to show a header label.
 *
 * The column keeps a real `headerName`, so screen readers announce the column
 * and e2e can select it, but the title is drawn visually hidden instead of
 * squashed into a 24-48px header cell.
 *
 * The grid must route headers through `AGGridHeader` (`defaultColDef`'s
 * `headerComponentParams.innerHeaderComponent`, which
 * `createReckonListGridDefaultColDef` already sets for list grids).
 */
export const visuallyHiddenHeaderProps = (
  headerName: string
): Pick<ColDef, 'headerName' | 'headerComponentParams'> => {
  return {
    headerName,
    headerComponentParams: { visuallyHiddenTitle: true },
  };
};
